module.exports = __webpack_public_path__ + "img/choose-up-Up Social Educational.6cb15df4.png";